import { ResponseType } from '@reviews/interfaces';

export const DescriptionTicketTemplates: { [key: string]: string } = {
    [ResponseType.Response_needed]: `We have received a review and need your input.

Before we can post a manager response on the concerns the guest presented, we need more information. Please update the specific steps or actions involved in correcting the issues and any other relevant information to the ticket notes.

Once updated, reassign to: LoraJean Harryman

Main Concerns:
-
-
-

Full Review Text:
"(REVIEW)"
`,

    [ResponseType.Feedback_FYI]: `A guest left private feedback when submitting a review. We are passing it along so any necessary action can be taken. Once reviewed, you may close this ticket. Next steps are at your discretion.

Please note, do not reassign this ticket back. If further action is needed, either create a new ticket for the appropriate team or use the resources below.

Guest contact or compensation requests can be posted in the Slack channel #ops-gx.

For review-related questions, email repmanagement@vacasa.com.

Key Information:

Guest requested follow-up: (Y/N)

Full review text: "(REVIEW)"
`,
};
